import { globalObservability } from "@opendoor/observability/slim";
//#region src/sagas.ts
/**
* Users are encouraged to use try/catch clauses in their sagas.
*
* However, if they do not, or an unexpected exception occurs,
* we set up the saga middleware with this handler as the handler
* of last resort:
*
* const sagaMiddleware = createSagaMiddleware({ onError: sagaMiddlewareErrorHandler });
*/
var sagaMiddlewareErrorHandler = (error) => {
	const Sentry = globalObservability.getSentryClient();
	Sentry.withScope?.((scope) => {
		scope.setTag("source", "saga");
		Sentry.captureException?.(error);
	});
};
//#endregion
export { sagaMiddlewareErrorHandler };

//# sourceMappingURL=sagas.mjs.map